export default "__VITE_ASSET__DjhvvZnU__"